import Patrol from "../fragments/patrol";

export default `
query QueryPatrolsByServiceProviderIdUpdatedAtIndex($serviceProviderId: ID!, $from: Float!, $after: ID) {
  queryPatrolsByServiceProviderIdUpdatedAtIndex(
    serviceProviderId: $serviceProviderId, 
    from: $from,
    after: $after
  ) {
    nextToken
    items ${Patrol}
  }
}
`;
